import { NgModule } from "@angular/core";

import { RuntimeConfigModule } from "../runtime-config";

import { CrossStorageService } from "./cross-storage.service";

@NgModule({
  imports: [RuntimeConfigModule],
  providers: [CrossStorageService]
})
export class CrossStorageModule {}
